<template>
  <el-config-provider :size="size" :z-index="zIndex">
    <Default />
    <OverlayLoading v-if="mutationLoading" />
    <transition>
      <Feedback
        v-if="feedback"
        :type="feedback.type"
        :heading="feedback.heading"
        :supplement="feedback.supplement"
      />
    </transition>
  </el-config-provider>
</template>

<script lang="ts" setup>
import Default from '@spectee/layouts/defaultLayout.vue';
import OverlayLoading from '@spectee/components/Organisms/OverlayLoading/index.vue';
import { ElConfigProvider } from 'element-plus';
import { createOverlayLoading } from '@spectee/composables/useOverlayLoading';
import { createFeedback } from '@spectee/composables/useFeedback';
import Feedback from '@spectee/components/Molecules/Feedback/index.vue';

const mutationLoading = createOverlayLoading();

const { props: feedback } = createFeedback();

const zIndex = 3000;
const size = 'large';
</script>
